
import { Component, Vue, Prop } from "vue-property-decorator";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import FormModal from "@/components/base/FormModal.vue";
import { getAffiliateSearch } from "@/api/user";
import { IBaseAutocomplete } from "@/types";

@Component({
    components: { FormModal, BaseAutocomplete },
    methods: { getAffiliateSearch },
})

export default class AccessAdvertiserForm extends Vue {
    @Prop({ default: false }) showModal!: boolean;
    selectedIds: number[] = [];
    onChange(ids: number[]): void {
        this.selectedIds = ids;
    }
    onClose(): void {
        this.$emit("close");
    }
    onSave(): void {
        if (!this.selectedIds.length) return;
        this.$emit("success", this.selectedIds);
    }
    get affiliateAutocomplete(): IBaseAutocomplete {
        return {
            apiMethod: getAffiliateSearch,
            errorText: "Партнёры не загружены",
            placeholder: "Начните вводить имя или ID",
            itemValue: "id",
            rules: [
                (v) => (
                    Array.isArray(v)
                        ? v.length > 0
                        : !!v
                ) || "Поле обязательно для заполнения",
            ],
            template: (i) => `${i.id} ${i.first_name} ${i.last_name}`,
            multiple: true,
            multiPaste: true,
        };
    }
}
